import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ToggleGroup } from 'components/_common/ToggleGroup';
import { LengthUnits, RTRMetricUnit, UserSystemGroup } from 'store/storeTypes';
import { mobileStyles } from './MobileSettings.styles';

interface MobileDTFUnitsProps {
  userSettings: any;
  updatedSettings: any;
  handleChangeLength: (event: React.MouseEvent<HTMLElement>, newVal: any) => void;
  handleChangeMetrics: (event: React.MouseEvent<HTMLElement>, newVal: any) => void;
}

const MobileDTFUnits: React.FC<MobileDTFUnitsProps> = ({
  userSettings,
  updatedSettings,
  handleChangeLength,
  handleChangeMetrics,
}) => {
  const { t } = useTranslation();

  if (!userSettings.data.userSystemGroup?.includes(UserSystemGroup.DTF)) {
    return null;
  }

  return (
    <Box sx={mobileStyles.section}>
      <Box sx={mobileStyles.sectionTitleWrapper}>
        <Typography variant="h3" sx={mobileStyles.sectionTitle}>
          {t('settings.dtfUnits')}
        </Typography>
      </Box>
      <Box sx={mobileStyles.sectionList}>
        <Box sx={mobileStyles.sectionListItem}>
          <Box sx={mobileStyles.sectionListItemWrapper}>
            <Box sx={mobileStyles.sectionListItemLeftPart}>
              <Typography sx={mobileStyles.sectionListItemTitle}>{t('settings.length')}</Typography>
            </Box>
            <Box sx={mobileStyles.sectionListItemRightPart}>
              <ToggleGroup
                value={
                  updatedSettings && updatedSettings.hasOwnProperty('lengthUnits')
                    ? updatedSettings.lengthUnits
                    : userSettings.data?.lengthUnits
                }
                onChange={handleChangeLength}
                name={'lengthUnits'}
                data={[
                  {
                    value: LengthUnits.Yard,
                    label: 'Yard',
                  },
                  {
                    value: LengthUnits.Meter,
                    label: 'Meter',
                  },
                ]}
              />
            </Box>
          </Box>
        </Box>
        <Box sx={mobileStyles.sectionListItem}>
          <Box sx={mobileStyles.sectionListItemWrapper}>
            <Box sx={mobileStyles.sectionListItemLeftPart}>
              <Typography sx={mobileStyles.sectionListItemTitle}>
                {t('settings.rtrMetrics')}
              </Typography>
            </Box>
            <Box sx={mobileStyles.sectionListItemRightPart}>
              <ToggleGroup
                value={
                  updatedSettings && updatedSettings.hasOwnProperty('rtrMetricUnit')
                    ? updatedSettings.rtrMetricUnit
                    : userSettings.data?.rtrMetricUnit
                }
                name={'rtrMetricUnit'}
                onChange={handleChangeMetrics}
                data={[
                  {
                    value: RTRMetricUnit.Linear,
                    label: 'Linear',
                  },
                  {
                    value: RTRMetricUnit.Square,
                    label: 'Square',
                  },
                ]}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MobileDTFUnits;
